import React from 'react';
import { useConfiguration } from '../../context/configuration-context/use-configuration';
const Component = React.lazy(() => import(/* webpackChunkName: "wc-ricos-editor" */ './ricos-editor'));
const RicosEditorLazy = (props) => {
    const isSSR = typeof window === 'undefined';
    const { pluginConfig } = useConfiguration();
    const [editorPluginConfig, setEditorPluginConfig] = React.useState();
    const loadEditorPluginsAsync = pluginConfig?.type === 'async' && pluginConfig.loadEditorPluginsAsync;
    React.useEffect(() => {
        if (loadEditorPluginsAsync) {
            loadEditorPluginsAsync().then(setEditorPluginConfig);
        }
    }, [loadEditorPluginsAsync]);
    return isSSR ? null : (React.createElement(React.Suspense, { fallback: props.fallback ?? null },
        React.createElement(Component, { ...props, pluginConfig: pluginConfig?.type === 'async'
                ? {
                    type: 'async',
                    plugins: editorPluginConfig,
                    onLoadFinished: async () => {
                        loadEditorPluginsAsync && (await loadEditorPluginsAsync());
                    },
                }
                : { type: 'sync', plugins: pluginConfig } })));
};
export default RicosEditorLazy;
//# sourceMappingURL=ricos-editor-lazy.js.map